import React, { useState } from 'react';
import Utils from '../../helpers/Utils';
import Input from '../../components/Input';
import Button from '../../components/Button';
import AuthPage, { AuthLink } from '../../components/AuthPage';
import useAPI from '../../hooks/useAPI';
import { useFormatter } from '../../hooks/useFormatter';
import Notification from '../../components/Notification';

export default function ForgotPassword () {
    const [email, setEmail] = useState('');
    const [busy, setBusy] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errors, setErrors] = useState({
        email: '',
    });

    const api = useAPI();
    const formatter = useFormatter();

    const resetPassword = (e) => {
        e.preventDefault();

        let _errors = {};
        if (!email) {
            _errors.email = "Email address required";
        } else if (!Utils.emailValid(email)) {
            _errors.email = "Email address invalid";
        }

        setErrors(_errors);

        if (Object.keys(_errors).length) {
            return setErrors(_errors);
        }

        setBusy(true);

        api.json('POST', '/auth/request-password-reset', {
            email,
        })
            .then(r => r.json())
            .then((response) => {
                if (response.errors) {
                    return setErrors({
                        ...errors,
                        ...formatter.flattenErrors(response.errors)
                    });
                }

                setSuccessMessage('Password reset sent. Please check your email for further instructions.');
                setEmail('');
            })
            .catch((error) => {
                alert(error);
            })
            .then(() => setBusy(false));
    };

    return (
        <AuthPage title="Reset your password">
            {
                successMessage ?
                    <div className="row">
                        <div className="col-12">
                            <Notification
                                type="success"
                                title="Success"
                                onClose={() => {
                                    setSuccessMessage('');
                                }}
                            >
                                {successMessage}
                            </Notification>
                        </div>
                    </div>
                    : null
            }
            <div className="row">
                <div className="col-12">
                    <Input
                        error={errors.email}
                        placeholder="tom@example.com"
                        label="Email Address"
                        maxLength="128"
                        value={email}
                        onChange={(e) => {
                            setEmail(e.target.value);
                            setSuccessMessage('');
                            setErrors({ ...errors, email: '' });
                        }}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Button
                        busy={busy}
                        className="button-full button-primary"
                        onClick={resetPassword}
                    >
                        Reset Password
                    </Button>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <AuthLink to={`/login`}>Nevermind, go back to login</AuthLink>
                </div>
            </div>
        </AuthPage>
    );
};